'use strict'
export default angular.module("mars.vet.dnareports.controllers.adultweight",[]).controller('AdultWeightController',
  function($rootScope, $scope, $routeParams, $window, EntryService, NavigationService, EntryIDService, ImageService, WeightListService, TranslationService, reportdata) {
      'ngInject';

      let sampleDetails = reportdata.sampleDetails;

      var reportType = 'online';
      $scope.onloadFun = function() {
          reportType = 'pdf';
      }
      EntryService.getEntry(EntryIDService.getEntryID('Adult Weight')).then(function(response) {
        var fields = response.fields;
        if (reportType != 'pdf') {
            $rootScope.pageTitle = fields.title;
        }
        $scope.title = fields.title;
        $scope.description = fields.description;
        $scope.subTitle = fields.subTitle;
        $scope.pdMsgArray = [];
        $scope.descriptionArray = [];
        $scope.weightUnit = TranslationService.getTranslation('WeightMeasure');
        $scope.predictedMessage = fields.predictedMessage.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);;
        $scope.bodyWeightDescription = fields.bodyWeightDescription.replaceAll('[DOG NAME]', sampleDetails.petDetails.petName);;

        ImageService.getImageUrl('6IuGlHxtS0wo4WKAayuokQ').then(function(response) {
            $scope.nutrition = response.data.fields.file.url;
        });
        ImageService.getImageUrl('1jW4X1zE3O6EkIEYygos8G').then(function(response) {
            $scope.excercise = response.data.fields.file.url;
        });

        angular.forEach($scope.description.split("\n"), function(value, key) {
            if (value != '') {
                $scope.descriptionArray.push(value);
            }
        });
        $scope.weightList = WeightListService.getWeightList();

        NavigationService.setNavigationUrls();
        $window.ga('send', 'pageview', {
            'page': $rootScope.pageTitle
        });

    }, function(error) {
        // promise rejected, could log the error with:
        // console.log('error', error);
    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/adultweight.controller.js